import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

const rateUpsertAdapter = createEntityAdapter({
    selectId: (rate) => (rate && (rate.id || rate._id)) || "unknown_id", // Safe fallback
});


// Async thunk for upserting rates
export const upsertRates = createAsyncThunk(
    "rateUpsert/upsert",
    async ({ file }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("Rates", file);

            const response = await request({
                endpoint: "/admin/upsertRates",
                method: "POST",
                body: formData,
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (!response.success || typeof response.data.modifiedCount !== "number") {
                return rejectWithValue(response.error || "Failed to upsert rates");
            }

            return {
                id: new Date().toISOString(), // Generate unique ID
                ...response.data,
            };
        } catch ({ error }) {
            return rejectWithValue(error.message || "Failed to upsert rates");
        }
    }
);
export const fetchRateData = createAsyncThunk(
    "rate/fetch",
    async ({ courierId, mode, weight }, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/admin/getRateByData",
                method: "GET",
                params: { courierId, mode, weight },
            });
            if (!response.success || !response.data) {
                return rejectWithValue(response.error.message || "Failed to fetch escalation data");
            }
            return response.data;
        }
        catch ({ error }) {
            return rejectWithValue(error.message || "Failed to fetch escalation data");
        }
    }
);
export const UpdateSingleRate = createAsyncThunk(
    "rate/UpdateSingleRate",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/admin/updateRates/",
                method: "PUT",
                params: { id },
                body: data,
            })
            if (!response.success || !response.data) {
                return rejectWithValue(response.error.message || "Failed to Update rate");
            }
            return response.data;

        }
        catch ({ error }) {
            return rejectWithValue(error.message || "Failed to Update rate");
        }
    }

)
const rateUpsertSlice = createSlice({
    name: "rateUpsert",
    initialState: rateUpsertAdapter.getInitialState({
        loading: false,
        error: null,
    }),
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(upsertRates.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(upsertRates.fulfilled, (state, action) => {
                state.loading = false;
                rateUpsertAdapter.upsertOne(state, action.payload);
            })
            .addCase(upsertRates.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            //fetchRateData
            .addCase(fetchRateData.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchRateData.fulfilled, (state, action) => {
                state.status = "succeeded";
                rateUpsertAdapter.setAll(state, action.payload || []); // Set fetched rates
            })
            .addCase(fetchRateData.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Something went wrong";
            })
            //UpdateSingleRate
            .addCase(UpdateSingleRate.pending, (state) => {
                state.status = "loading";
            })
            .addCase(UpdateSingleRate.fulfilled, (state, action) => {
                state.status = "succeeded";
                rateUpsertAdapter.upsertOne(state, action.payload); // Update the rate
            })
            .addCase(UpdateSingleRate.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Something went wrong";
            })
    },
});

export default rateUpsertSlice.reducer;
export const {
    selectAll: selectAllRates,
    selectById: selectRateById,
    selectIds: selectRateIds,
} = rateUpsertAdapter.getSelectors((state) => state.rateUpsert);
